import script from "./TimelineBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./TimelineBlock.vue?vue&type=script&setup=true&lang=js"

import "./TimelineBlock.vue?vue&type=style&index=0&id=67d2e64c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67d2e64c"]])

export default __exports__